import i18n from 'i18next';
import { string } from 'yup';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ fields, totalTrucks, vehicle, renderComp }) => {
  return {
    form_checkCameraFeature: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER]),
      default: () => false,
    },
    form_payload: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => ({ webFleetUid: fields.webFleetUid }),
      default: () => ({}),
    },
    form_triggerLatLong: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    form_modalhead: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => i18n.t('common.insurancePortalWarning'),
      default: () => `You are changing vehicle count to ${totalTrucks} vehicles`,
    },
    form_btn_label_secodary: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => i18n.t('common.ok'),
      default: () => i18n.t('common.cancel'),
    },
    form_btn_label_primary: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => i18n.t('common.proceedToAdd'),
      default: () => i18n.t('common.ok'),
    },
    initialval: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => ({ notes: vehicle?.vehicleDetails?.notes }),
      default: () => ({ notes: vehicle?.vehicleDetails?.lienholder || '' }),
    },
    schema_grade: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => {
        if (!hasRestrictedRole([ROLES.FLMANAGER]) || renderComp)
          return {
            garagingAddress: string().required(i18n.t('common.fieldRequiredMessage')),
            garagingCity: string().required(i18n.t('common.fieldRequiredMessage')),
            garagingState: string().required(i18n.t('common.fieldRequiredMessage')),
            garagingZipCode: string().required(i18n.t('common.fieldRequiredMessage')),
            radiusCompliance: string().required(i18n.t('common.fieldRequiredMessage')),
          };
        return {};
      },
      default: () => ({}),
    },
    schema_layout_clutch: {
      [SERVICE_PROVIDERS.SPIREON]: () => ({
        vin: string().when(['deviceType'], {
          is: (value) => value === 'ELD',
          then: string()
            .required(i18n.t('common.fieldRequiredMessage'))
            .matches(/[^\WqioqIOQ]+$/, i18n.t('common.isValidVin'))
            .test('len', i18n.t('common.isValidVin'), (val) => val?.length === 17),
          otherwise: string(),
        }),
      }),
      default: () => ({
        vin: string()
          .required(i18n.t('common.fieldRequiredMessage'))
          .matches(/[^\WqioqIOQ]+$/, i18n.t('common.isValidVin'))
          .test('len', i18n.t('common.isValidVin'), (val) => val?.length === 17),
      }),
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
